import {__} from '@wordpress/i18n';
import {registerBlockType} from '@wordpress/blocks';

import edit from './edit';
import save from './save';

import { containerIcon } from '../../assets/icons/icons';
import {Icon} from '@wordpress/components';

registerBlockType('buba-blocks/container', {
    apiVersion: 2,
    title: __('Container'),
    category: 'buba',
    icon: <Icon icon={containerIcon}/>,
    attributes: {
        verticalAlignment: {
            type: 'string'
        },
        width: {
            type: 'number',
        },
        spacing: {
            type: 'object',
            default: {
                padding: {
                    top: {
                        typeSpacing: 'none',
                        number: 0,
                        label: __('Padding Top'),
                    },
                    right: {
                        typeSpacing: 'none',
                        number: 0,
                        label: __('Padding Right'),

                    },
                    bottom: {
                        typeSpacing: 'none',
                        number: 0,
                        label: __('Padding Bottom'),

                    },
                    left: {
                        typeSpacing: 'none',
                        number: 0,
                        label: __('Padding Left'),
                    },
                },
                margin: {
                    top: {
                        typeSpacing: 'none',
                        number: 0,
                        label: __('Margin Top'),
                    },
                    bottom: {
                        typeSpacing: 'none',
                        number: 0,
                        label: __('Margin Bottom'),

                    },
                }
            }
        },
        mediaId: {
            type: 'number'
        },
        mediaUrl: {
            type: 'string',
        },
        mediaType: {
            type: 'string'
        },
        backgroundSize:{
            type: 'string',
            default: 'cover',
        },
        backgroundPosition:{
            type: 'string',
            default: '',
        },
        backgroundRepeat:{
          type: 'string',
        },
        focalPoint: {
            type: 'object',
            default:{
              x: 0.5,
              y: 0.5,
            },
        },
        backgroundAttachment:{
            type: 'string',
            default: '',
        },
        dimRatio: {
            type: 'number',
            default: 50
        },
        overlayColor: {
            type: 'string',
            default: '',
        },
        customOverlayColor: {
            type: 'string'
        },
        gradient: {
            type: 'string',
        },
        customGradient: {
            type: 'string'
        },
    },
    supports: {
        anchor: true,
        lightBlockWrapper: true,
        color: { // This also enables text and background UI controls.
            gradient: true // Enable gradients UI control.
        }
    },
    edit,
    save,
});
